module.exports = __webpack_public_path__ + "files/7991d2cb090ef11f167dabfbc4aec01e.png";